/* Lotus Edition accessibility helpers */
(function () {
  function markNewTab() {
    document.querySelectorAll('.lx-root a[target="_blank"]').forEach(function (a) {
      if (a.hasAttribute('data-lx-nt')) return;
      a.setAttribute('data-lx-nt', '');
      var lab = a.getAttribute('aria-label');
      if (lab) { if (!/new tab/i.test(lab)) a.setAttribute('aria-label', lab + ' (opens in new tab)'); return; }
      var s = document.createElement('span');
      s.className = 'lx-sr';
      s.textContent = ' (opens in new tab)';
      a.appendChild(s);
    });
  }
  function syncTabs() {
    document.querySelectorAll('.lx-tab').forEach(function (t) {
      t.removeAttribute('aria-checked');
      t.setAttribute('aria-pressed', t.classList.contains('is-active') ? 'true' : 'false');
    });
  }
  function init() {
    markNewTab();
    syncTabs();
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.lx-tab, [data-filter-link], .lx-cat')) setTimeout(syncTabs, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
